import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import request from '../api';
import Calendar from './Calendar';
import { miloAlert } from '../AlertDialog';
import { CheckIn as checkinCore } from '@tencent/milo-core';
var queryCheckin = checkinCore.query.bind(checkinCore);
var checkin = checkinCore.checkin.bind(checkinCore);

var CheckInComp = /*#__PURE__*/function () {
  function CheckInComp(option) {
    _classCallCheck(this, CheckInComp);

    this.month = new Date().getMonth() + 1;
    this.year = new Date().getFullYear();
    this.option = _objectSpread({
      showCalendar: true,
      msg: {
        systemError: '很抱歉，系统繁忙，请稍后再试',
        hasCheckin: '您今天已签到',
        checkinSuccess: '签到成功',
        checkinFailure: '签到成功'
      }
    }, option);
  }

  _createClass(CheckInComp, [{
    key: "query",
    value: function query() {
      var _this = this;

      var _ref = this.option || {},
          iActivityId = _ref.iActivityId,
          iQueryFlowId = _ref.iQueryFlowId,
          flowConfig = _ref.flowConfig,
          onQuerySuccess = _ref.onQuerySuccess,
          onQueryFail = _ref.onQueryFail;

      var queryOption = {
        iActivityId: iActivityId,
        iFlowId: iQueryFlowId,
        flowConfig: flowConfig
      };
      request(queryCheckin, queryOption).then(function (res) {
        if (res.ret == '0') {
          var signDataList = _this.formatData(res);

          _this.render(res.total, signDataList);

          if (onQuerySuccess) {
            onQuerySuccess(res);
          }
        } else {
          if (onQueryFail) {
            onQueryFail(res);
          } else {
            miloAlert(res.msg || '很抱歉，系统繁忙，请稍后再试');
          }
        }
      })["catch"](function (err) {
        if (err.errCode && parseInt(err.errCode) === -1) {
          // 登陆错误统一处理
          return;
        }

        if (onQueryFail) {
          onQueryFail(err);
        } else {
          miloAlert(err.errMsg || err.sMsg || err.msg || '很抱歉，系统繁忙，请稍后再试');
        }
      });
    }
  }, {
    key: "checkIn",
    value: function checkIn() {
      var _this2 = this;

      var _ref2 = this.option || {},
          iActivityId = _ref2.iActivityId,
          iCommitFlowId = _ref2.iCommitFlowId,
          flowConfig = _ref2.flowConfig,
          onHasChecked = _ref2.onHasChecked,
          onCheckInSuccess = _ref2.onCheckInSuccess,
          onCheckInFail = _ref2.onCheckInFail,
          msg = _ref2.msg;

      var commitOption = {
        iActivityId: iActivityId,
        iFlowId: iCommitFlowId,
        flowConfig: flowConfig
      };
      request(checkin, commitOption).then(function (res) {
        if (res.iRet == 0) {
          _this2.query();

          if (onCheckInSuccess) {
            onCheckInSuccess(res);
          } else {
            miloAlert(msg.checkinSuccess);
          }
        } else if (res.iRet == 101) {
          if (onHasChecked) {
            onHasChecked(res);
          } else {
            miloAlert(msg.hasCheckin);
          }
        } else {
          if (onCheckInFail) {
            onCheckInFail(res);
          } else {
            miloAlert(res.msg || msg.systemError);
          }
        }
      })["catch"](function (err) {
        console.log(err);

        if (err.errCode && parseInt(err.errCode) === -1) {
          // 登陆错误统一处理
          return;
        }

        if (onCheckInFail) {
          onCheckInFail(err);
        } else {
          miloAlert(err.errMsg || err.sMsg || err.msg || msg.systemError);
        }
      });
    }
  }, {
    key: "formatData",
    value: function formatData(res) {
      var _ref3 = res || {},
          data = _ref3.data,
          month = _ref3.month,
          year = _ref3.year;

      this.result = res;
      this.month = month;
      this.year = year;
      return (data || []).map(function (item) {
        return {
          iDate: item.FupdateDate,
          isSign: 1
        };
      });
    }
  }, {
    key: "render",
    value: function render(total, signDataList) {
      var selectedDays = (signDataList || []).map(function (item) {
        return item.iDate;
      });

      if (this.option.showCalendar) {
        var _ref4 = this.option.calOption || {},
            sepecialDays = _ref4.sepecialDays,
            containerID = _ref4.containerID;

        var cal = new Calendar({
          month: this.month,
          year: this.year,
          selectedDays: selectedDays,
          sepecialDays: sepecialDays,
          containerID: containerID
        });
        cal.show();
      }
    }
  }]);

  return CheckInComp;
}();

export { CheckInComp as default };
export var CheckIn = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new CheckInComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '签到模块初始化失败'
        });
      }
    });
  }
};